
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".778","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M6.496 14c-.357 0-.576-.15-.659-.453-.082-.302.007-.61.268-.926l5.494-7.325H6.413c-.452 0-.679-.22-.679-.658 0-.425.227-.638.68-.638h6.316c.412 0 .666.15.762.453.096.288.02.583-.227.884L7.71 12.704h5.432c.453 0 .679.212.679.638 0 .438-.226.658-.68.658H6.497z","fill":"#313131"}})])
          )
        }
      }
    